import {
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Full-page screen shown when a guest opens a share link whose validity period has lapsed.
 * Reuses the session-expired screen's visual language. Deliberately offers no action: the
 * guest has no account to sign in to and can only ask the author for a fresh link.
 */
@Component({
  selector: 'app-link-expired',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './link-expired.component.html',
  styleUrls: ['./link-expired.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkExpiredComponent {}
